import { cloneDeep } from 'lodash';

export const getTreeData = (arr: any[], faKey: string, key: string) => {
  const treeData: any[] = [];
  arr.forEach((el: any) => {
    if (!el[faKey]) {
      treeData.push(el);
    } else {
      const faItem = arr.find((item: any) => item[key] === el[faKey]);
      if (!faItem) return;
      if (faItem.children) {
        faItem.children.push(el);
      } else {
        faItem.children = [el];
      }
    }
  });
  return treeData;
};

export const getChildIds = (list: any, id: string) => {
  if (!list) return [];
  let childList: any[] = [];
  const getChildList = (list: any, id: string) => {
    list.forEach((el: any) => {
      if (el.id === id) {
        childList = el.children;
        return;
      }
      if (el.children && el.children.length > 0) {
        getChildList(el.children, id);
      }
    });
  };
  getChildList(list, id);
  const idList: string[] = [];
  const getListIds = (list: any) => {
    if (!list) return;
    list.forEach((el: any) => {
      idList.push(el.id);
      if (el.children && el.children.length > 0) {
        getListIds(el.children);
      }
    });
  };
  getListIds(childList);
  return idList;
};

export const getDataFromId = (list: any[], id: string) => {
  if (!list) return {};
  let data: any = {};
  const getItem = (list: any[], id: string) => {
    list.forEach((el: any) => {
      if (el.id === id) {
        data = el;
        return;
      }
      if (el.children && el.children.length > 0) {
        getItem(el.children, id);
      }
    });
  };
  getItem(list, id);
  return data;
};

export const filterShowTreeData = (treeData: any, keys: string[]) => {
  if (keys.length === 0 || !treeData.children) {
    return {
      ...treeData,
      children: undefined,
    };
  }
  treeData.show = true;
  const getShowTag = (list: any, keys: string[]) => {
    list.forEach((el: any) => {
      if (keys.includes(el.key)) {
        el.show = true;
      }
      if (el.children && el.children.length > 0) {
        getShowTag(el.children, keys);
      }
    });
  };
  getShowTag(treeData.children, keys);
  const getFatherShowTag = (list: any) => {
    list.forEach((el: any) => {
      if (!el.show && el.children && el.children.length > 0) {
        const isChildShow = JSON.stringify(el.children).includes('"show":true');
        if (isChildShow) {
          el.show = true;
        }
      }
      if (el.children && el.children.length > 0) {
        getFatherShowTag(el.children);
      }
    });
  };
  getFatherShowTag(treeData.children);
  const filterFromShowTag = (list: any[], arr: any[]) => {
    list.forEach((el: any) => {
      if (!el.show) return;
      const node = {
        ...el,
        children: [],
      };
      arr.push(node);
      if (el.children && el.children.length > 0) {
        filterFromShowTag(el.children, node.children);
      }
    });
  };
  const arr: any[] = [];
  filterFromShowTag(treeData.children, arr);
  return {
    ...treeData,
    children: arr,
  };
};

export const formatShowTreeData = (treeData: any) => {
  treeData.label = treeData.title;
  treeData.id = treeData.key;
  const getFormat = (list: any) => {
    list.forEach((el: any) => {
      el.label = el.title;
      el.id = el.key;
      if (el.children && el.children.length > 0) {
        getFormat(el.children);
      }
    });
  };
  if (treeData.children && treeData.children.length > 0) {
    getFormat(treeData.children);
  }
  return treeData;
};
